import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, RefreshCw, Rss } from "lucide-react";
import { useApi } from "@/lib/api";

export const CalendarFeedCard = () => {
  const api = useApi();
  const [url, setUrl] = useState("");
  useEffect(() => {
    api("get", "/calendar-feed").then((r) => setUrl(r.url)).catch(() => {});
  }, [api]);

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    toast.success("Calendar link copied");
  };
  const rotate = async () => {
    if (!window.confirm("Make a new link? Anyone using the old link will stop getting updates and must re-add the new one.")) return;
    setUrl((await api("post", "/calendar-feed/rotate")).url);
    toast.success("New private link created");
  };

  if (!url) return null;
  return (
    <div className="mb-6 rounded-2xl border border-[#E6E2DA] bg-white p-5" data-testid="calendar-feed-card">
      <div className="flex items-start gap-3">
        <Rss className="mt-0.5 shrink-0 text-[#A67C00]" size={20} />
        <div className="min-w-0 flex-1">
          <p className="font-semibold">Show this schedule in Google Calendar (no keys needed)</p>
          <p className="mt-1 text-sm text-[#5C5850]">Every visit request, confirmed visit and project date flows into any Google, Apple or Outlook calendar that adds this private link. Google checks for new bookings every few hours. You also get an email with an "Add to Google Calendar" button for each new booking.</p>
          <div className="mt-3 flex flex-col gap-2 sm:flex-row">
            <input readOnly value={url} onFocus={(e) => e.target.select()} data-testid="calendar-feed-url" className="h-10 min-w-0 flex-1 rounded-md border border-[#DDE2EA] bg-[#FAF8F5] px-3 font-mono-num text-xs" />
            <button onClick={copy} data-testid="calendar-feed-copy-btn" className="inline-flex items-center justify-center gap-1.5 rounded-full bg-[#F2B91C] px-4 py-2 text-sm font-bold text-[#0E1F3F] hover:bg-[#D9A30F]"><Copy size={14} />Copy link</button>
            <button onClick={rotate} data-testid="calendar-feed-rotate-btn" className="inline-flex items-center justify-center gap-1.5 rounded-full border border-[#E6E2DA] px-4 py-2 text-sm font-semibold hover:border-[#0E1F3F]"><RefreshCw size={14} />New link</button>
          </div>
          <p className="mt-2 text-xs text-[#8C877D]">In Google Calendar on a computer: Other calendars → + → From URL → paste → Add calendar. Keep this link private — anyone with it can see your schedule.</p>
        </div>
      </div>
    </div>
  );
};
